import React from "react";
import { motion } from "framer-motion";
import {
  doc,
  updateDoc,
  increment,
  deleteDoc,
  collection,
  where,
  getDocs,
  collectionGroup,
  writeBatch,
  query,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { MdDelete } from "react-icons/md";
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";

function Minipost({
  postid,
  ind,
  title,
  tumbnail,
  publishedby,
  category,
  content,
}) {
  const [comments, setComments] = useState(0);
  const [bookmarks, setBookmarks] = useState(0);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(false);

  let navigate = useNavigate();

  const routeChange = (titre, identifier) => {
    const nav = `/post/${titre}=${identifier}`;
    navigate(nav);
  };

  const getShortVesr = content ? content.substring(0, 330) + "..." : "";

  const getShortTitle = title ? title.substring(0, 40) + "..." : "";

  const getUsers = async () => {
    const userColRef = collection(db, "users");

    const result = await getDocs(userColRef);

    const utilisateurs = [];
    result.docs.forEach((doc) => {
      utilisateurs.push({ id: doc.id, data: doc.data() });
    });
    setUsers(utilisateurs);
    setLoader(true);
  };

  useEffect(() => {
    getUsers();
  }, []);

  const deletePostBookmarks = () => {
    if (loader === true && users.length > 0) {
      users.forEach((user) => {
        const postRef = doc(db, "users", user.id, "Bookmarks", postid);
        deleteDoc(postRef);
      });
    }
  };

  const deletePost = async (useId, cat, pstid) => {
    deletePostBookmarks();

    const postRef = doc(db, "users", useId, "Categories", cat, "Posts", pstid);

    await deleteDoc(postRef);

    const count = "count";
    const colRef = doc(
      db,
      "users",
      useId,
      "Categories",
      cat,
      "Posts",
      pstid,
      "postComments",
      count
    );

    await updateDoc(colRef, {
      count: increment(-1),
    });
  };

  const commentsCount = async () => {
    const colRef = collection(
      db,
      "users",
      publishedby,
      "Categories",
      category,
      "Posts",
      postid,
      "postComments"
    );

    const snapshot = await getDocs(colRef);
    const totalComments = snapshot.size;
    setComments(totalComments);
  };

  useEffect(() => {
    commentsCount();
  }, []);

  const bookmarksCOunt = async () => {
    const colRef = query(
      collectionGroup(db, "Bookmarks"),
      where("postID", "==", postid)
    );

    const snapshot = await getDocs(colRef);
    const totalBookmarks = snapshot.size;
    setBookmarks(totalBookmarks);
  };

  useEffect(() => {
    bookmarksCOunt();
  }, []);

  return (
    <motion.div
      className="w-[95%] h-36 flex flex-row py-2 pl-2 bg-[#181818] rounded-xl hover:cursor-pointer hover:bg-[#141414] transition-all ease-in-out"
      key={ind}
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      transition={{
        ease: "easeIn",
        duration: 0.5,
      }}
      exit={{ opacity: 0 }}
    >
      <div
        className="w-[27%] h-full rounded-lg overflow-hidden"
        onClick={() => {
          routeChange(title, postid);
        }}
      >
        <img
          src={tumbnail}
          referrerPolicy="no-referrer"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-[73%] flex flex-col px-3 py-1 overflow-hidden justify-between">
        <div className="flex flex-row w-full justify-between">
          <div
            className="font-semibold text-zinc-200"
            onClick={() => {
              routeChange(title, postid);
            }}
          >
            {getShortTitle}
          </div>
          <div className="flex flex-row">
            <MdDelete
              size={28}
              className="fill-inputLabel hover:fill-DarkBlue hover:scale-110 transition-all ease-in-out"
              onClick={() => deletePost(publishedby, category, postid)}
            />
          </div>
        </div>
        <div
          className="w-full h-[50%] overflow-hidden text-sm"
          onClick={() => {
            routeChange(title, postid);
          }}
        >
          {parse(getShortVesr)}
        </div>
        <div className="flex flex-row">
          <div className="flex flex-row items-center text-sm text-inputLabel font-medium">
            {comments - 1}
            <span className="text-sm ml-1">comments</span>
          </div>
          <span className="mx-3">|</span>
          <div className="flex flex-row items-center text-sm text-inputLabel font-medium">
            {bookmarks}
            <span className="text-sm ml-1">Bookmarks</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Minipost;
